import script from "./message-timestamp.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-timestamp.vue?vue&type=script&setup=true&lang=ts"

import "./message-timestamp.vue?vue&type=style&index=0&id=327c13df&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-327c13df"]])

export default __exports__